<app-hidden-upload-input
  #hiddenFileInput
  (filesChange)="registerFileAdded($event)"
  (filesChangeRaw)="registerFileAddedRaw($event)"
  [allowMultipleFiles]="allowMultipleFiles"
  [allowSameFileUpload]="allowSameFileUpload"
  [acceptFileTypes]="acceptFileTypes"
></app-hidden-upload-input>

<ng-content>
  <div
    aria-hidden="true"
    (click)="hiddenFileInput.openFileUploadWindow()"
    [ngClass]="{ 'disabled text-navy-500': disabled }"
    [appTooltip]="tooltipText"
    tooltipPosition="bottom"
    class="flex align-baseline justify-center cursor-pointer text-blue-700 max-h-[30px]"
  >
    <span [ngClass]="[iconClass]"></span>
  </div>
</ng-content>
